import { animate, state, style, transition, trigger } from '@angular/animations';

export const QuickQuestionAnimation = trigger('questionStep', [
  state(
    'open',
    style({
      opacity: 1,
    }),
  ),
  state(
    'closed',
    style({
      opacity: 0,
      height: '0px',
      margin: 0,
    }),
  ),
  transition('open => closed', [animate('180ms cubic-bezier(0.5, 1, 0.89, 1)')]),
  transition('closed => open', [animate('180ms cubic-bezier(0.5, 1, 0.89, 1)')]),
]);
